const sensors = function (robotType, blockSeparator, categorySeparator) {
    switch (robotType) {
        case 'E6':
            return `<category
                        name="%{BKY_CATEGORY_SENSOR}"
                        id="sensor"
                        colour="#4bb4ff"
                        secondaryColour="#368ccc"
                        showLabelButton="true">
                    <block type="sensor_setColorLamp"/>
                    ${blockSeparator}
                    <block type="sensor_getTouch"/>
                    ${blockSeparator}
                    <block type="sensor_setLightSensor"/>
                    <block type="sensor_getLightSensorDigital"/>
                    <block type="sensor_getLightSensor"/>
                    ${blockSeparator}
                    <block type="sensor_getUltrasonicCompare">
                        <value name="DATA">
                            <shadow type="math_number">
                                <field name="NUM">10</field>
                            </shadow>
                        </value>
                    </block>
                    <block type="sensor_getUltrasonic"/>
                    ${blockSeparator}
                    <block type="sensor_colorDetectionCompare"></block>
                    <block type="sensor_colorDetectionMode"></block>
                    <block type="sensor_colorDetection"/>
                    ${blockSeparator}
                    <block type="sensor_getWifiCamRockCtrlNew"/>
                    <block type="sensor_getWifiPictureData"/>
                    <block type="sensor_getCamRecogData">
                        <value name="DATA">
                            <shadow type="math_number">
                                <field name="NUM">0</field>
                            </shadow>
                        </value>
                    </block>
                    <block type="sensor_getWifiCamPictureResult"/>
                    <block type="sensor_getWifiCamPictureSize"/>
                    <block type="sensor_getWifiCamPictureSite"/>
                    ${categorySeparator}
                    </category>
                    `;
        case 'C1':
            return `<category
                    name="%{BKY_CATEGORY_SENSOR}"
                    id="sensor"
                    colour="#4bb4ff"
                    secondaryColour="#368ccc">
                    <block type="sensor_getLightSensor"/>
                    <block type="sensor_getLightSensorDigital"/>
                    <block type="sensor_getIRDist"/>
                    <block type="sensor_setLightSensor"/>
                    ${categorySeparator}
                    </category>
                    `;
            // <block type="sensor_getTouch"/>     这两个块暂时不需要，先注释，但其相关的函数定义先保留，以便后期恢复使用
            // <block type="sensor_getUltrasound"/>
        case 'E3':
            return `<category
                        name="%{BKY_CATEGORY_SENSOR}"
                        id="sensor"
                        colour="#4bb4ff"
                        secondaryColour="#368ccc">
                    <block type="sensor_setColorLamp"/>
                    <block type="sensor_getTouch"/>
                    <block type="sensor_getLightSensor"/>
                    <block type="sensor_getLightSensorDigital"/>
                    <block type="sensor_setLightSensor"/>
                    <block type="sensor_setMusicPlayer"/>
                    <block type="sensor_setFan">
                        <value name="SPEND">
                            <shadow type="text">
                                <field name="TEXT">50</field>
                            </shadow>
                        </value>
                    </block>
                    <block type="sensor_getCompoI"/>
                    <block type="sensor_getIRDistE3"/>
                    <block type="sensor_getRemoIR"/>
                    <block type="sensor_getUltrasoundE3"/>
                    <block type="sensor_getCompassB"/>
                    <block type="sensor_getGSensor"/>
                    <block type="sensor_getVolume"/>
                    <block type="sensor_getMagnet"/>
                    <block type="sensor_getDTHSensor"/>
                    <block type="sensor_getAirQuality"/>
                    <block type="sensor_setAHRS"/>
                    <block type="sensor_getAHRS"/>
                    <block type="sensor_getPhoto"/>
                    <block type="sensor_getInfrared"/>
                    <block type="sensor_colorDetection"/>
                    <block type="sensor_getColorSensor"/>
                    <block type="sensor_setIR">
                        <value name="STATUS">
                            <shadow type="math_number">
                                <field name="NUM">0</field>
                            </shadow>
                        </value>
                    </block>
                    <block type="sensor_getIRDete"/>
                    <block type="sensor_setIRCode">
                        <value name="CODE">
                            <shadow type="math_number">
                                <field name="NUM">5</field>
                            </shadow>
                        </value>
                    </block>
                    <block type="sensor_getIRCode"/>
                    <block type="sensor_getTouchA"/>
                    <block type="sensor_getTouchB"/>
                    <block type="sensor_setIRBoard">
                        <value name="ADDRESS">
                            <shadow type="math_number">
                                <field name="NUM">0</field>
                            </shadow>
                        </value>
                        <value name="COLOR">
                            <shadow type="math_number">
                                <field name="NUM">0</field>
                            </shadow>
                        </value>
                    </block>
                    ${categorySeparator}
                    </category>
                    `;
        case 'M6':
            return `<category
                        name="%{BKY_CATEGORY_SENSOR}"
                        id="sensor"
                        colour="#4bb4ff"
                        secondaryColour="#368ccc"
                        showLabelButton="true">
                    <block type="sensor_setColorLamp"/>
                    ${blockSeparator}
                    <block type="sensor_getTouch"/>
                    ${blockSeparator}
                    <block type="sensor_getLightSensor"/>
                    <block type="sensor_getLightSensorDigital"/>
                    <block type="sensor_setLightSensor"/>
                    ${blockSeparator}
                    <block type="sensor_getUltrasonicCompare">
                        <value name="DATA">
                            <shadow type="math_number">
                                <field name="NUM">10</field>
                            </shadow>
                        </value>
                    </block>
                    <block type="sensor_getUltrasonic"/>
                    ${blockSeparator}
                    <block type="sensor_colorDetectionCompare"></block>
                    <block type="sensor_colorDetectionMode"></block>
                    <block type="sensor_colorDetection"/>
                    ${blockSeparator}
                    <block type="sensor_getWifiCamRockCtrlNew"/>
                    <block type="sensor_getWifiPictureData"/>
                    <block type="sensor_getCamRecogData">
                        <value name="DATA">
                            <shadow type="math_number">
                                <field name="NUM">0</field>
                            </shadow>
                        </value>
                    </block>
                    <block type="sensor_getWifiCamPictureResult"/>
                    <block type="sensor_getWifiCamPictureSize"/>
                    <block type="sensor_getWifiCamPictureSite"/>
                    ${categorySeparator}
                    </category>
                    `;
        case 'C6':
            return `<category
                        name="%{BKY_CATEGORY_SENSOR}"
                        id="sensor"
                        colour="#4bb4ff"
                        secondaryColour="#368ccc"
                        showLabelButton="true">
                    <block type="sensor_setColorLamp"/>
                    ${blockSeparator}
                    <block type="sensor_getTouch"/>
                    ${blockSeparator}
                    <block type="sensor_getLightSensor"/>
                    <block type="sensor_getLightSensorDigital"/>
                    <block type="sensor_setLightSensor"/>
                    ${blockSeparator}
                    <block type="sensor_getUltrasonicCompare">
                        <value name="DATA">
                            <shadow type="math_number">
                                <field name="NUM">10</field>
                            </shadow>
                        </value>
                    </block>
                    <block type="sensor_getUltrasonic"/>
                    ${blockSeparator}
                    <block type="sensor_colorDetectionCompare"></block>
                    <block type="sensor_colorDetectionMode"></block>
                    <block type="sensor_colorDetection"/>
                    ${blockSeparator}
                    <block type="sensor_getWifiCamRockCtrlNew"/>
                    <block type="sensor_getWifiPictureData"/>
                    <block type="sensor_getCamRecogData">
                        <value name="DATA">
                            <shadow type="math_number">
                                <field name="NUM">0</field>
                            </shadow>
                        </value>
                    </block>
                    <block type="sensor_getWifiCamPictureResult"/>
                    <block type="sensor_getWifiCamPictureSize"/>
                    <block type="sensor_getWifiCamPictureSite"/>
                    ${categorySeparator}
                    </category>
                    `;
        case 'E7':
            return `<category
                        name="%{BKY_CATEGORY_SENSOR}"
                        id="sensor"
                        colour="#4bb4ff"
                        secondaryColour="#368ccc"
                        showLabelButton="true">
                    <block type="E7_sensor_getTouch"/>
                    <block type="sensor_isUltra">
                        <value name="VALUE">
                            <shadow type="math_number">
                                <field name="NUM">15</field>
                            </shadow>
                        </value>
                    </block>
                    <block type="E7_sensor_getUltrasonic"/>
                    <block type="sensor_isElectedData">
                        <value name="VALUE">
                            <shadow type="math_number">
                                <field name="NUM">1000</field>
                            </shadow>
                        </value>
                    </block>
                    <block type="E7_sensor_getLightSensor"/>
                    <block type="sensor_setElcLightIfData">
                        <value name="VALUE">
                            <shadow type="math_number">
                                <field name="NUM">1000</field>
                            </shadow>
                        </value>
                    </block>

                    <block type="sensor_isColor"/>
                    <block type="E7_sensor_colorDetection"/>
                    <block type="sensor_waitNewColor"/>
                    <block type="sensor_waitThisColor"/>
                    <block type="E7_sensor_setColorLamp"/>
                    <block type="E7_sensor_setLightByRGB">
                        <value name="R">
                            <shadow type="math_number">
                                <field name="NUM">0</field>
                            </shadow>
                        </value>
                        <value name="G">
                            <shadow type="math_number">
                                <field name="NUM">0</field>
                            </shadow>
                        </value>
                        <value name="B">
                            <shadow type="math_number">
                                <field name="NUM">0</field>
                            </shadow>
                        </value>
                    </block>
                    ${false && `<block type="E7_getPressureData"/>
                    <block type="E7_getVoiceData"/>
                    <block type="E7_getTSDData"/>
                    <block type="E7_getWDData"/>
                    <block type="E7_getSDData"/>
                    <block type="E7_getYDData"/>
                    <block type="E7_getAirQualityData"/>
                    <block type="E7_getRFIDNum"/>
                    <block type="E7_getRFIDData"/>
                    <block type="E7_setRFIDData">
                        <value name="VALUE">
                            <shadow type="math_number">
                                <field name="NUM">255</field>
                            </shadow>
                        </value>
                    </block>
                    <block type="E7_setAttitudeModel"/>
                    
                    <block type="E7_getEyeData"/>
                    <block type="E7_getEyeRedData"/>
                    <block type="E7_setEyeRedData">
                        <value name="VALUE">
                            <shadow type="math_number">
                                <field name="NUM">50</field>
                            </shadow>
                        </value>
                    </block>
                    <block type="E7_setEyeModel">
                        <value name="COLOR1">
                            <shadow type="colour_picker_Red">
                            </shadow>
                        </value>
                    </block>
                    <block type="E7_setEyeColor">
                        <value name="COLOR1">
                            <shadow type="colour_picker_Red">
                                
                            </shadow>
                        </value>
                        <value name="COLOR2">
                            <shadow type="colour_picker_Orange">
                                
                            </shadow>
                        </value>
                        <value name="COLOR3">
                            <shadow type="colour_picker_Yellow">
                                
                            </shadow>
                        </value>
                        <value name="COLOR4">
                            <shadow type="colour_picker_Green">
                                
                            </shadow>
                        </value>
                        <value name="COLOR5">
                            <shadow type="colour_picker_Blue">
                                
                            </shadow>
                        </value>
                        <value name="COLOR6">
                            <shadow type="colour_picker_Indigo">
                                
                            </shadow>
                        </value>
                        <value name="COLOR7">
                            <shadow type="colour_picker_Purple">
                                
                            </shadow>
                        </value>
                        <value name="COLOR8">
                            <shadow type="colour_picker_White">
                                
                            </shadow>
                        </value>
                    </block>`}
                    
                    <block type="E7_getAttitudeData"/>
                    <block type="E7_getAccData"/>
                    ${false && <block type="E7_getMagneticData"/>}
                    <block type="E7_getGyroscopeData"/>
                    <block type="E7_getTempAndHumData"/>
                    ${categorySeparator}
                    </category>
                    `;
        case 'STORM_OS':
            return `<category
                        name="%{BKY_CATEGORY_SENSOR}"
                        id="sensor"
                        colour="#4bb4ff"
                        secondaryColour="#368ccc"
                        showLabelButton="true"
                    >
                        <block type="STORM_OS_getLightSensor"/>
                        <block type="STORM_OS_getLightSensor_values"/>
                        <block type="STORM_OS_set_photo_electric_threshold">
                            <value name="VALUE">
                                <shadow type="math_number">
                                    <field name="NUM">0</field>
                                </shadow>
                            </value>
                        </block>
                        <block type="STORM_OS_light_open"/>
                        <block type="STORM_OS_light_close"/>
                        <block type="STORM_OS_touch_value"/>
                        <block type="STORM_OS_touch_values"/>
                        <block type="STORM_OS_getColorRGB"/>
                        <block type="STORM_OS_getColorRGB_values"/>
                        <block type="STORM_OS_getUltrasonic"/>
                        <block type="STORM_OS_getUltrasonic_values"/>
                        <block type="STORM_OS_humidity_value"/>
                        <block type="STORM_OS_humidity_values"/>
                        <block type="STORM_OS_temperature_value"/>
                        <block type="STORM_OS_temperature_values"/>
                        <block type="STORM_OS_compass_value"/>
                        <block type="STORM_OS_compass_values"/>
                        <block type="STORM_OS_gyroscope_init"/>
                        <block type="STORM_OS_gyroscope_value"/>
                        <block type="STORM_OS_gyroscope_values"/>
                        <block type="STORM_OS_set_color_light"/>
                        <block type="STORM_OS_set_color_lights"/>
                    </category>
                    
                    `;
        case 'M5':
            return `<category
                        name="%{BKY_CATEGORY_SENSOR}"
                        id="sensor"
                        colour="#4bb4ff"
                        secondaryColour="#368ccc">
                    <block type="sensor_M5_GetButton"/>
                    <block type="sensor_M5_GetLightSensor"/>
                    <block type="sensor_M5_Set3CLed"/>
                    <block type="sensor_M5_GetMIC"/>
                    <block type="sensor_M5_GetPotentiometer"/>
                    <block type="sensor_M5_GetTiltAxis"/>
                    <block type="sensor_M5_GetUltrasonic"/>

                    <block type="sensor_M5_GetColorSensor"/>
                    <block type="sensor_M5_GetPhotosensitive"/>
                    <block type="sensor_M5_GetShortIRDist"/>

                    ${false && `<block type="sensor_M5_GetRFID522"></block>

                    <block type="sensor_M5_ReadRFID522Card">
                        
                        <value name="CARDNUMBER">
                            <shadow type="math_number">
                                <field name="NUM">1</field>
                            </shadow>
                        </value>
            
                    </block>
                    <block type="sensor_M5_WriteRFID522Card">
                        
                        <value name="CARDNUMBER">
                            <shadow type="math_number">
                                <field name="NUM">1</field>
                            </shadow>
                        </value>
                        <value name="DATA">
                            <shadow type="math_number">
                                <field name="NUM">1</field>
                            </shadow>
                        </value>
                    </block>`}
                    
                    ${categorySeparator}
                    </category>
                    `;
        default:
            return `<category
                            name="%{BKY_CATEGORY_SENSOR}"
                            id="sensor"
                            colour="#4bb4ff"
                            secondaryColour="#368ccc">
                        </category>
                        `;
    }
};

export default sensors
;
